import React from 'react';


function Button(props){
    let className = 'seehi_button';
    if(props.isAnswered){
        className += ' seehi_answered';
    }
    if(props.isSelected){
        className += ' seehi_selected';
    }
    return <span className={className} tabIndex="0"
            onKeyDown={(e) => ( e.keyCode !== 13 || props.onSelect(props.value) )}
            onClick={(e) => ( props.onSelect(props.value)) }
        >{props.label}</span>;
}

Button.defaultProps = {
    value:  null,
    label: 'Button',
    onSelect: (v) => (false),
    isAnswered: false,
    isSelected: false
};

export default Button;


// WEBPACK FOOTER //
// ./src/elements/button.js